<template>
  <Layout>
    <div class="page-container">
      <PageHeader :title="title" :subTitle="subTitle">
        <template #afterTitle>
          <McButton
            icon="icon-outline_arrow-left"
            variant="secondary"
            :text="$t('global.back')"
            @click="$router.push({ name: 'Setting' })"
          />
        </template>
      </PageHeader>

      <!-- Uncomment when needed -->
      <!-- <McInlineFilter -->
      <!--   :filterItems="inlineFilterItems" -->
      <!--   :activeKeys="activeFilters['status.name']" -->
      <!--   @update:activeKeys="handleChangeActiveFilters([{ key: 'status.name', values: $event }])" -->
      <!-- /> -->

      <McEditableTable
        ref="table"
        searchable
        :fields="additionalCostListFields"
        :apiClient="apiClient"
        hasBulkDelete
        withCard
        activeFilters="activeFilters"
        hasEmit:submitError
        :apiErrorMappings="apiErrorMappings"
        :submitError="handleSubmitError"
      >
        <template #actions="data">
          <McButton
            v-if="data.selectedIdsLength"
            variant="secondary-red"
            class="me-2"
            id="mc-delete-btn"
            :text="$t('global.delete')"
            icon="icon-outline_trash"
            @click="data.deleteModal.show()"
          />

          <TransitionStatus
            v-if="data.selectedIdsLength"
            :selectedIdsLength="data.selectedIdsLength"
            :disabled="data.disabledGlobal"
            @transition="handleTransition($event, data)"
          />

          <McButton
            variant="primary"
            :disabled="data.disabledGlobal"
            :text="$t('global.addField')"
            icon="icon-fill_plus"
            @click="data.handleAdd"
          />
        </template>
      </McEditableTable>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2.vue'
import McButton from '@/components/McButton'
import McEditableTable from '@/components/McEditableTable'
// import McInlineFilter from '@/components/McInlineFilter'

import TransitionStatus from './components/TransitionStatus'

// import inlineFilterItems from './lib/constants/inline-filter-items'
import additionalCostListFields from './lib/fields/additional-cost-list-fields'
import apiErrorMappings from './lib/constants/api-error-mappings'

import * as AdditionalCost from '@/services/rest-api/lib/additional-cost/additional-cost'
import * as AdditionalCostTransition from '@/services/rest-api/lib/additional-cost/transition'

export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButton,
    // McInlineFilter,
    McEditableTable,
    TransitionStatus,
  },
  data() {
    return {
      // inlineFilterItems,
      activeFilters: {},
    }
  },
  computed: {
    title() {
      return this.$t('setting.homePage.additionalCost')
    },
    subTitle() {
      return this.$t('setting.homePage.textAdditionalCost')
    },
    apiErrorMappings() {
      return apiErrorMappings
    },
    additionalCostListFields() {
      return additionalCostListFields
    },
    apiClient() {
      return {
        get: AdditionalCost.get,
        show: AdditionalCost.show,
        store: AdditionalCost.store,
        update: AdditionalCost.update,
        delete: AdditionalCost.deleteMany,
      }
    },
  },
  methods: {
    // Since we need to call methods from child (McEditableTable),
    // we pass the methods from child to this component using scoped slots
    async handleTransition(status, data) {
      const ids = Object.keys(data.selectedIds).filter((key) => data.selectedIds[key])

      const res = await AdditionalCostTransition.transition({ ids, status })

      if (res.errors) {
        this.$mcToast.error('Gagal mengubah status')
        return
      }

      this.$mcToast.success('Berhasil mengubah status')

      await data.getData({ limit: 10, page: 1 })
      data.handleUnselectAll()
      data.handleSortChange()
    },
    handleSubmitError(data) {
      if (data.errors && data.status == 400) {
        if (data.errors.name && data.errors.name[0] == 'value is not unique') {
          this.$mcToast.error('Gagal simpan. Jenis Produk sudah terdaftar di sistem.')
          return
        }

        this.$mcToast.error('Terdapat kesalahan format pada input anda')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.page-container {
  .__status-dots {
    display: inline-block;
    margin: auto;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 8px;
  }
}
</style>
